import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import * as React from 'react'

export interface InputProps extends React.ComponentProps<'input'> {
  right?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, right: propsRight, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false)

    const right = React.useMemo<React.ReactNode>(() => {
      if (type === 'password') {
        return (
          <div
            className="cursor-pointer flex items-center w-8 justify-center"
            onClick={() => setShowPassword(prev => !prev)}>
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} size={'lg'} />
          </div>
        )
      } else {
        return propsRight
      }
    }, [showPassword, type])

    return (
      <div
        className={clsx(
          'flex items-center justify-center gap-2 h-12 rounded-xl border border-input bg-gray-100 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className,
          right && 'pr-4',
        )}>
        <input
          type={type === 'password' && showPassword ? 'text' : type}
          className={clsx('w-full px-3 py-2 bg-transparent outline-none')}
          ref={ref}
          {...props}
        />
        <div className={'text-shadow-grey font-medium mb-1'}>{right}</div>
      </div>
    )
  },
)
Input.displayName = 'Input'

export { Input }
